import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Payment failed',
    id: 'AccountSelectionPage.failedTitle',
  },
  text: {
    defaultMessage: 'Your payment failed',
    id: 'AccountSelectionPage.failedText',
  },
  terminateFlow: {
    defaultMessage: 'Cancel',
    id: 'AccountSelectionPage.terminateFlow',
  },
  hint: {
    defaultMessage: 'Please retry your payment or cancel.',
    id: 'AccountSelectionPage.terminableHint',
  },
  noRetriesTitle: {
    defaultMessage: 'Your payment failed',
    id: 'AccountSelectionPage.failedTitleNoRetries',
  },
});
